/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'waste': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M218.89 216.02h38.31v116.84h-38.31zM273.22 216.02h38.31v116.84h-38.31z"/><path pid="1" d="M316.93 361H202.31l-10.55-164.17H329L316.93 361zM246.1 151h30.14v15.87H246.1V151zm-30.22-29.6v45.84h-78.45v29.59h22.68l13.57 193.77h170.45l15.07-193.77H383v-29.59h-76.94V121.4h-90.18zM479 256a222.041 222.041 0 01-46.27 136c-4.842 6.262-4.269 15.244 1.33 20.84l1 1a15.806 15.806 0 0011.188 4.643 15.81 15.81 0 0012.482-6.113c70.83-91.832 70.83-220.868 0-312.7A15.804 15.804 0 00435 98.18l-1 1c-5.569 5.608-6.116 14.576-1.27 20.82A222.041 222.041 0 01479 256zM33 256a222.04 222.04 0 0146.35-136.1c4.78-6.219 4.199-15.116-1.35-20.66l-1.17-1.17a15.673 15.673 0 00-23.47 1.46c-70.952 91.878-70.952 221.062 0 312.94a15.673 15.673 0 0023.47 1.46l1.17-1.17c5.539-5.552 6.108-14.448 1.32-20.66A222.04 222.04 0 0133 256z" fill-rule="nonzero"/>'
  }
})
